import { render, staticRenderFns } from "./ConsultarSolicitacaoAlteracaoValorForm.vue?vue&type=template&id=590cb75c&scoped=true"
import script from "./ConsultarSolicitacaoAlteracaoValorForm.vue?vue&type=script&lang=js"
export * from "./ConsultarSolicitacaoAlteracaoValorForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultarSolicitacaoAlteracaoValorForm.vue?vue&type=style&index=0&id=590cb75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590cb75c",
  null
  
)

export default component.exports